module.exports = __webpack_public_path__ + "static/media/dhl-logo-grey.7aaab2aa.png";